export default function() {
  return this._source.cancel();
}
